import { EvaluateIllustration, PlanIllustration, SetupIllustration } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../components/Page/Page';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

export const TimetablePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()} title={t('timetable.title', { count: 1 })}>
      <IconMenu headline={t('common.whatToDo')}>
        <IconMenuItem
          label={t('timetable.setup')}
          icon={<SetupIllustration />}
          bubbleType={14}
          onClick={() => navigate(t('routes.setup.slug'))}
        />
        <IconMenuItem
          label={t('timetable.plan')}
          icon={<PlanIllustration />}
          bubbleType={16}
          onClick={() => navigate(t('routes.plan.slug'))}
        />
        <IconMenuItem
          label={t('timetable.evaluate')}
          icon={<EvaluateIllustration />}
          bubbleType={17}
          onClick={() => navigate(t('routes.evaluate.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
